import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { toggle } from '~/Redux/Modules/StickerPacksUi';
import { closeModal } from '~/Redux/Modules/Modal';
import history from '~/Providers/History';
import Modal from '~/Containers/Global/Modal/Modal';
import './OnboardingProgressModal.scss';
import { ONBOARDING_PROGRESS_MODAL } from '~/Config/Modals';
import { setDropdownOpen } from '~/Redux/Modules/HandwritingUi';
import ArtfulCheckbox from '../Form/ArtfulCheckbox';
import yayImage from './yay.png';

function OnboardingProgressModal({
  modalId,
  completionPercentage,
  onboardingTasks,
  toggleStickers,
  stickersOpen,
  closeModal,
  setDropdownOpen,
}) {
  const taskRoutes = {
    connectCalendar: '/add-accounts',
    chooseCover: '/choose-cover-list',
    createList: '/lists',
  };

  const handleTaskClick = step => {
    const route = taskRoutes[step];
    if (step === 'selectHandwritingFont') {
      closeModal(modalId);
      setTimeout(() => {
        setDropdownOpen(true);
        if (typeof window !== 'undefined') {
          const event = new window.Event('native.openStyleDropdown');
          window.dispatchEvent(event);
        }
        setTimeout(() => {
          setDropdownOpen(false);
        }, 500);
      }, 300);
    } else if (step === 'placeSticker') {
      closeModal(modalId);
      if (history.location.pathname === '/lists') {
        history.push('/month');
      }
      toggleStickers(!stickersOpen);
    } else if (route) {
      closeModal(modalId);
      history.push(route);
    }
  };

  return (
    <Modal id={modalId} overlayClassName="onboarding-progress-modal" showCloseButton>
      <div className="onboarding-progress-content">
        <div className="centered-image">
          <img src={yayImage} alt="Yay!" />
        </div>
        <p className="message">
          {onboardingTasks.remaining > 0
            ? 'Complete these items to earn a free premium cover and sticker pack!'
            : 'Congratulations! Your free premium cover and sticker pack have been unlocked!'}
        </p>
        <div className="tasks">
          {onboardingTasks.list.map((task, index) => (
            <div
              key={index}
              className="task-wrapper"
              onClick={() => handleTaskClick(task.step)}
              style={{ cursor: 'pointer' }}
            >
              <div className="task">
                <ArtfulCheckbox label={task.title} value={task.isCompleted} />
              </div>
            </div>
          ))}
        </div>
        <div className="progress-bar-wrapper">
          <div className="progress-bar-container">
            <div className="progress-bar" style={{ width: `${completionPercentage}%` }} />
          </div>
          <span className="progress-percentage">{`${completionPercentage.toFixed(0)}%`}</span>
        </div>
      </div>
    </Modal>
  );
}

const calculateCompletionPercentage = tasks => {
  const totalTasks = tasks.length;
  const completedTasks = tasks.filter(task => task.isCompleted).length;
  return totalTasks ? (completedTasks / totalTasks) * 100 : 0;
};

const mapStateToProps = ({ Onboarding, StickerPacksUi }) => {
  const onboardingTasks = Onboarding.onboarding.onboardingTasks;
  return {
    completionPercentage: calculateCompletionPercentage(onboardingTasks),
    onboardingTasks: {
      remaining: onboardingTasks.filter(task => !task.isCompleted).length,
      list: onboardingTasks,
    },
    stickersOpen: StickerPacksUi.tabOpen,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    toggleStickers: update => dispatch(toggle(update)),
    closeModal: modalId => dispatch(closeModal(modalId)),
    setDropdownOpen: open => dispatch(setDropdownOpen(open)),
  };
};

OnboardingProgressModal.propTypes = {
  modalId: PropTypes.string.isRequired,
  completionPercentage: PropTypes.number.isRequired,
  onboardingTasks: PropTypes.shape({
    remaining: PropTypes.number.isRequired,
    list: PropTypes.arrayOf(
      PropTypes.shape({
        step: PropTypes.shape({
          title: PropTypes.string.isRequired,
        }).isRequired,
        isCompleted: PropTypes.bool.isRequired,
      }).isRequired
    ).isRequired,
  }).isRequired,
  stickersOpen: PropTypes.bool,
  toggleStickers: PropTypes.func,
  closeModal: PropTypes.func,
  setDropdownOpen: PropTypes.func,
};

OnboardingProgressModal.defaultProps = {
  modalId: ONBOARDING_PROGRESS_MODAL,
};

export default connect(mapStateToProps, mapDispatchToProps)(OnboardingProgressModal);
